import { render, staticRenderFns } from "./sortList.vue?vue&type=template&id=48a5f425&scoped=true&"
import script from "./sortList.vue?vue&type=script&lang=js&"
export * from "./sortList.vue?vue&type=script&lang=js&"
import style0 from "./sortList.vue?vue&type=style&index=0&id=48a5f425&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a5f425",
  null
  
)

export default component.exports